import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {FormCardSection} from '@/components/ui/form-atoms/FormAtoms'
import {AlertCircleIcon} from '@/components/ui/icon/Icon'
import {StyledDetailsInformationPrimaryTextError} from '@/features/treatment-requests/components/treatment-request-patient-uneligible/style'
import {CSSProperties, useTheme} from 'styled-components'
import {Text, TextProps} from '@/components/ui/text/Text'

export const WarningBanner = ({
    title,
    subtitle,
    direction = 'column',
    textSize = 'textMd',
    maxWidth = 496
}: {
    title: string
    subtitle?: string
    direction?: 'row' | 'column'
    textSize?: TextProps['size']
    maxWidth?: CSSProperties['maxWidth']
}) => {
    const {palette} = useTheme()

    return (
        <FormCardSection columnGap={4.5} columns={1} padding={3} style={{maxWidth: maxWidth}}>
            <Flexbox direction={direction} align="center" gap={2}>
                <AlertCircleIcon size={15} color={palette.orange['600']} />
                <Flexbox direction="column" gap={0.5}>
                    <StyledDetailsInformationPrimaryTextError weight="500" size={textSize}>
                        {title}
                    </StyledDetailsInformationPrimaryTextError>
                    {subtitle && (
                        <Text size="textSm" palette="neutral" shade="500">
                            {subtitle}
                        </Text>
                    )}
                </Flexbox>
            </Flexbox>
        </FormCardSection>
    )
}
